export const LandingCohLogo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="98"
      height="102"
      viewBox="0 0 98 102"
      fill="none"
      className="absolute end-0 top-0 rotate-180 md:bottom-0 md:top-auto md:rotate-0"
    >
      <g opacity="0.5" clipPath="url(#clip0_8158_22443)">
        <path
          d="M88.3448 77.5639L79.4586 79.5956L91.0529 130.456L99.9391 128.425L88.3448 77.5639Z"
          fill="#CCC2BF"
        />
        <path
          d="M86.5642 56.7782L82.61 65.0027L129.546 87.6346L133.5 79.4101L86.5642 56.7782Z"
          fill="#CCC2BF"
        />
        <path
          d="M116.169 22.5908L69.2335 45.2227L73.1877 53.4472L120.124 30.8153L116.169 22.5908Z"
          fill="#CCC2BF"
        />
        <path
          d="M16.6365 24.6004L9.51013 30.2916L41.9885 71.0799L49.1149 65.3888L16.6365 24.6004Z"
          fill="#CCC2BF"
        />
        <path d="M52.593 79.8989H0.5V89.0271H52.593V79.8989Z" fill="#CCC2BF" />
        <path
          d="M66.0979 86.2318L33.6195 127.02L40.7459 132.711L73.2243 91.923L66.0979 86.2318Z"
          fill="#CCC2BF"
        />
        <path
          d="M60.9918 0.710938L49.3975 51.5716L58.2836 53.6033L69.878 2.74259L60.9918 0.710938Z"
          fill="#D5F477"
        />
      </g>
      <defs>
        <clipPath id="clip0_8158_22443">
          <rect width="133" height="132" fill="white" transform="translate(0.5 0.710938)" />
        </clipPath>
      </defs>
    </svg>
  );
};
